import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { ChecklistComponent } from './checklist.component';
import { AddChecklistComponent } from './add-checklist/add-checklist.component';
import { UnSavedChangesRouteGuard } from 'src/app/shared/routeguards/unsavedChangesRouteGuard';

const routes: Routes = [
  { path: '', component: ChecklistComponent },
  { path: 'addchecklist', component: AddChecklistComponent, canDeactivate: [UnSavedChangesRouteGuard] }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ChecklistRoutingModule { }
